import { SplitPaymentCash } from './SplitPaymentCash';
export default SplitPaymentCash